define(
    'viewmodels/secured/help/guided/nextSteps',[
        "viewmodels/ViewModel",
        "plugins/router",
        "helper/textParser",
        "services/session",
        "i19n!i19n/strings",
    ],
    function (ViewModel, router, textParser, session, i19n) {

        var vm = new ViewModel({
            i19n: i19n,
            id: '6',
            descriptions: ko.observableArray([]),
            todos: ko.observableArray([]),
        });

        vm.activate = function () {
            if (vm.descriptions().length == 0) {
                vm.descriptions.push("You have now completed your basic fileplan setup and are ready to start work. ");
                vm.descriptions.push("You can continue to fine tune your fileplan configuration at anytime now or in the future. ");
                //vm.descriptions.push("To get the most out of fileplan for your business and your people, have a look at the fileplan Optimisation Guide (?? title) for topics such as: ");
                vm.descriptions.push("To get the most out of fileplan for your business and your people, explore the resources available in the fileplan help centre.");
            }
            if (vm.todos().length == 0) {
                //vm.todos.push({ icon: '', isDone: false, html: textParser.toHtml('Document control') });
                //vm.todos.push({ icon: '', isDone: false, html: textParser.toHtml('Configuring fields') });
                //vm.todos.push({ icon: '', isDone: false, html: textParser.toHtml('Configuring columns in libraries ...') });
            }
        };
        vm.attached = function () {
            $(".a-route").unbind("click");
            $(".a-route").bind("click", function (e) {
                router.navigate($(this).attr("href"));

                return false;
            });
        };

        return vm;
    }
);
